// extracted by mini-css-extract-plugin
export default {"root":"jbFJUT","loader":"AnkhXt"};